export interface Product {
  id: string;
  name: string;
  type: string;
  image: string;
}

export interface Testable {
  dataTestId?: string;
}

export enum States {
  Default = 'default',
  Valid = 'valid',
  Invalid = 'invalid',
}

export enum Size {
  XXSmall = 'xxsmall',
  XSmall = 'xsmall',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum Position {
  Top = 'top',
  Bottom = 'bottom',
  Right = 'right',
  Left = 'left'
}

export enum ToastColor {
  BLACK,
  WHITE,
  BLUE,
  GREEN,
  ORANGE,
  RED,
}

export enum ToastActionType {
  PRIMARY,
  SECONDARY,
}

export enum ToastPosition {
  TOPLEFT,
  TOPMIDDLE,
  TOPRIGHT,
  BOTTOMLEFT,
  BOTTOMMIDDLE,
  BOTTOMRIGHT,
}

export enum ToastEntryDirection {
  TOP,
  BOTTOM,
  LEFT,
  RIGHT,
}

export interface NavLink {
  label: string;
  to: string;
  target?: string;
}

export interface NavSection {
  header: string;
  links: NavLink[];
}

export interface NavOptions {
  sections: NavSection[];
}
